module.exports = __webpack_public_path__ + "static/img/empty.be54c601.png";